import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "block-search" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "人员名单", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_5 = { class: "block-content" }
const _hoisted_6 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_input, {
        placeholder: "搜索员工",
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        onKeydown: _withKeys(_ctx.search, ["enter"]),
        "suffix-icon": "el-icon-search"
      }, null, 8, ["modelValue", "onKeydown"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "employee.name",
              width: "80",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "employee.idcard",
              label: "身份证号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "company_name",
              label: "被派遣单位"
            }),
            _createVNode(_component_el_table_column, {
              prop: "occupation_name",
              formatter: 
            (item) =>
            item.occupation_name +
            `（${item.occupation_level}类）`
            ,
              label: "所属工种"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "start_date",
              label: "保险起期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "end_date",
              label: "保险止期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "is_active",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  class: _normalizeClass(
                'dot ' +
                (scope.row.status == '保障中'
                ? 'dot-green'
                : 'dot-red')
                )
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(scope.row.status), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ])
  ]))
}